<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y :nudge-top="24" :max-width="useDays?'300px':'200px'">
    <template v-slot:activator="{ on }">
      <v-chip v-if="chip" :close="close" small v-on="on" @click:close="$emit('close')">{{label+' '+durationFormatted}}</v-chip>
      <v-text-field v-else
                    :label="label" :class="small?'text-body-2':''" readonly v-on="on" v-model="durationFormatted"
                    :disabled="disabled" :outlined="outlined" :dense="dense"
                    :persistent-hint="persistentHint" :hint="hint"
                    :hide-details="hideDetails"
                    append-icon="mdi-menu-down" @click:append="menu=true"
                    >
      </v-text-field>
    </template>
    <v-card>
      <v-container>
        <v-row no-gutters>
          <v-col v-if="useDays" cols="3">
            <v-combobox dense label="days" v-model="days" :items="daysList" @change="change"/>
          </v-col>
          <v-col :cols="useDays?3:5" :offset="useDays?1:0">
            <v-combobox dense label="hours" v-model="hours" :items="hoursList" @change="change"/>
          </v-col>
          <v-col :cols="useDays?3:5" :offset="useDays?1:2">
            <v-combobox dense label="mins" v-model="minutes" :items="minutesList" @change="change"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: 'DurationnPicker',
	props: {
		value: {type:Number,required:false,default:0},
    useDays: {type:Boolean, required:false,default:false},
		label: {type:String,required:false},
		disabled: {type:Boolean,required:false, default:false},
    small: {type:Boolean,required:false, default:false},
    persistentHint: {type:Boolean,required:false,default:false},
    hint: {type:String,required:false},
    outlined: {type:Boolean,required:false, default:true},
    dense: {type:Boolean,require:false,default:false},
    chip: {type:Boolean,require:false,default:false},
    close: {type:Boolean,require:false,default:false},
    options: {type: Boolean,required:false,default:false},
    hideDetails: {type:Boolean,required:false}
  },
  data() {
    return {
      menu: false,
      days: 0,
      hours: 0,
      minutes: 0,
      daysList: [],
      hoursList: [],
      minutesList: [],
      duration: this.value,
      durationFormatted: '',
    }
  },
  created() {
    for (let i = 0; i<= 30; i++)
      this.daysList.push(i);
    for (let i = 0; i<= 24; i++)
      this.hoursList.push(i);
    for (let i = 0; i<= 59; i++)
      this.minutesList.push(i);
    this.setParts();
  },
  watch: {
    value() {
      this.duration = this.value;
      this.setParts();
    }
  },
  methods: {
    setParts() {
      this.hours = Math.floor(this.duration / 60);
      if (this.useDays) {
        this.days = Math.floor(this.hours / 24);
        this.hours = this.hours - this.days * 24;
      }
      this.minutes = this.duration % 60;
      this.format();
    },
    format() {
      this.durationFormatted = `${this.useDays?`${this.days} days, `:''}${this.hours} hours, ${this.minutes} mins`;
    },
		change() {
      this.duration = parseInt(this.hours) * 60 + parseInt(this.minutes);
      if (this.useDays)
        this.duration += parseInt(this.days) * 24 * 60;
      if (isNaN(this.duration)) {
        this.hours = 0;
        this.minutes = 0;
        this.duration = 0;
      }
      this.format();
			this.$emit('input',this.duration);
			this.$emit('change',this.duration);
		}
  }
}
</script>